import { makeStyles } from "@material-ui/core";
import { fade } from "@material-ui/core/styles/colorManipulator";

const rootVariant = ({
  palette: {
    primary,
    grey,
    custom: { border, high },
  },
}) => ({
  default: {},
  card: {
    borderCollapse: "initial",
    borderSpacing: "0 8px",
    "& > thead > tr > th": {
      color: "#888",
      border: 0,
      lineHeight: 1,
      padding: "8px 8px",
    },
    "& > tbody > tr": {
      background: high,
      "& > th, & > td": {
        padding: "8px 8px",
        borderTop: `1px solid ${border["200"]}`,
        borderBottom: `1px solid ${border["200"]}`,
        "&:first-child": {
          borderLeft: `1px solid ${border["200"]}`,
          borderRadius: "4px 0 0 4px",
        },
        "&:last-child": {
          borderRight: `1px solid ${border["200"]}`,
          borderRadius: "0 4px 4px 0",
        },
      },
    },
  },
  striped: {
    "& > thead > tr": {
      "& > th": {
        height: 32,
        padding: "4px 8px",
        color: "#888",
      },
    },
    "& > tbody > tr": {
      "& > td, & > th": {
        height: 44,
        padding: "8px 8px",
        borderColor: border["200"],
      },
      "&:not(.Mui-selected):nth-child(odd)": {
        background: fade(high, 0.6),
      },
      "&.Mui-selected": {
        background: fade(primary.main, 0.1),
        "&:hover": {
          background: `${fade(primary.main, 0.2)} !important`,
        },
      },
      "&:hover": {
        background: `${fade(grey[500], 0.1)} !important`,
      },
    },
  },
});

const useRbTableStyles = makeStyles((theme) => ({
  root: (props) => rootVariant(theme)[props.variant],
}));

export default useRbTableStyles;
